import React, { useState, useEffect } from 'react';
import AppLayout from '../../layouts/app/AppLayout';
import AppIcons from '../../assets/images/icons';
import './custom.scss';
import PartnersSlider from '../../components/partnersSlider';

import { translateThis } from '../../helpers/language.helper';
import TeamSlider from '../../components/teamSlider';




const AboutUs = () => {
    // custom home functions here
    const pageName = "About Us";

    const [windowSize, setWindowSize] = useState([
        window.innerWidth,
        window.innerHeight,
    ]);

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper aboutUs-wrapper f-wrp">
                <div className='about-banner-wrapper f-wrp' style={{ height: `${windowSize[1] - 80}px` }}>
                    <div className='main-container-wrp'>
                        <div className='about-main-banner f-wrp'>
                            <div className='row' style={{ height: `${windowSize[1] - 100}px` }}>
                                <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                                    <div className='banner-img-sec f-wrp'>
                                        <span className='banner-main-img'><img src={AppIcons.aboutBanner} alt='about us' /></span>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                                    <div className='banner-content-box f-wrp'>
                                        <h1>{translateThis('About Us')}</h1>
                                        <p>{translateThis('aboutUsBannerText')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='about-project-wrapper f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='about-project-sec f-wrp'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div className='about-proj-box content-box f-wrp'>
                                        <h1>{translateThis('About the project')}</h1>
                                        <p>{translateThis('aboutTheProjectTextPara1')}</p>
                                        <p>{translateThis('aboutTheProjectTextPara2')}</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div className='about-proj-box content-withImg f-wrp'>
                                        <span className='proj-img'><img src={AppIcons.childrens} alt='children' /></span>
                                        <p>{translateThis('Empowering communities through sustainable and profitable initiatives, creating lasting value for all stakeholders')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='partners-slider-wrapper f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='partners-slider-sec f-wrp'>
                            <PartnersSlider />
                        </div>
                    </div>
                </div>
                <div className='team-slider-wrapper f-wrp'>
                    <div className='team-slider-sec f-wrp'>
                        <div className='team-slide-header f-wrp'>
                            <h1>{translateThis('Meet our')} <b>{translateThis('team')}</b></h1>
                            <p>{translateThis('teamHeaderText')}</p>
                        </div>
                        <div className='team-main-wrp f-wrp'>
                            <TeamSlider />
                        </div>
                    </div>
                </div>
















            </div>
        </AppLayout>
    )
}

export default AboutUs;